module.exports = __webpack_public_path__ + "img/icon_home_taocan_nor@2x.49a652ed.png";